import React from "react";

const DataComponent = () => {
  return <div>DataComponent</div>;
};
export default DataComponent;
